import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LeadForm from 'bundles/leads/form';
import {
  addLead,
  updateLead,
  hideLeadModal,
  hideLeadModalAlert
} from 'bundles/project/actions/index';
import { Modal } from '@buildoutinc/blueprint-react/ui/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/pro-solid-svg-icons';
import { fetchConnectableObjects } from '../../actions/index';

export function LeadModal(props) {
  const addLead = (contact, leadData) => {
    props.addLead(props.project.id, contact, leadData);
    props.fetchConnectableObjects(props.project.id);
  };

  const updateLead = (leadData) => {
    const updatedLeadData = { ...leadData, id: props.leadToEdit.id };
    props.updateLead(props.project.id, updatedLeadData);
  };

  const title = props.leadToEdit ? 'Update Lead' : 'Add a Lead';

  return (
    <Modal open={props.show} onClose={props.hideLeadModal}>
      <Modal.Content size="lg">
        <Modal.Header>
          <Modal.Title className="d-flex gap-2 align-items-center">
            <FontAwesomeIcon className="text-primary" icon={faUserPlus} />
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LeadForm
            availableDatabaseOptions={props.availableDatabaseOptions}
            condoListings={props.project.condoListings}
            contacts={props.project.contacts}
            errorMessage={props.errorMessage}
            hideLeadModal={props.hideLeadModal}
            hideLeadModalAlert={props.hideLeadModalAlert}
            key={`${props.show}-${props.leadToEdit && props.leadToEdit.id}`}
            lead={props.leadToEdit}
            leadReferralSources={props.leadReferralSources}
            leadStatuses={props.leadStatuses}
            leaseChecked={props.project.leaseChecked}
            leaseSpaceListings={props.project.leaseSpaceListings}
            lotListings={props.project.lotListings}
            projectId={props.project.id}
            requestSending={props.requestSending}
            saleChecked={props.project.saleChecked}
            saleListing={props.project.listing}
            showAlert={props.showAlert}
            useVaultGates={props.project.useVaultGates}
            onSave={props.leadToEdit ? updateLead : addLead}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
}

LeadModal.propTypes = {
  addLead: PropTypes.func.isRequired,
  availableDatabaseOptions: PropTypes.array.isRequired,
  errorMessage: PropTypes.string,
  fetchConnectableObjects: PropTypes.func.isRequired,
  hideLeadModal: PropTypes.func.isRequired,
  hideLeadModalAlert: PropTypes.func.isRequired,
  leadReferralSources: PropTypes.array,
  leadStatuses: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  leadToEdit: PropTypes.object,
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
    condoListings: PropTypes.array,
    contacts: PropTypes.array,
    leaseChecked: PropTypes.bool,
    leaseSpaceListings: PropTypes.array,
    lotListings: PropTypes.array,
    listing: PropTypes.object,
    saleChecked: PropTypes.bool,
    useVaultGates: PropTypes.bool
  }).isRequired,
  requestSending: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  showAlert: PropTypes.bool,
  updateLead: PropTypes.func.isRequired
};

const mapStateToProps = ({ availableDatabaseOptions, LeadModal, project }) => ({
  ...LeadModal,
  availableDatabaseOptions,
  project
});

export default connect(mapStateToProps, {
  addLead,
  fetchConnectableObjects,
  hideLeadModal,
  hideLeadModalAlert,
  updateLead
})(LeadModal);
